// Map #4 Verdant Alien World, audio half. A turquoise-sky jungle under two suns that glows after dark.
// Ambience: warm humid air and rustling fronds, a pulsing shimmer of alien insects (louder at night), a low crystal hum,
// strange whooping calls, buzzing fliers, drips into the luminous pools, bubbling pools, alien song-birds by day, croakers
// and crystal tones at night. Lush echo.
// Music: F lydian, 100 bpm, wonder and strangeness: FM kalimba arps, a round gliding bass, an airy triangle pad, a glassy
// lead, shaker and brush percussion.
import { MODES, type MapAudioDef } from '../../audio/mapAudioDef';

export const AUDIO: MapAudioDef = {
  id: 'verdant-alien',
  ambience: {
    level: 1.15,
    beds: [
      { src: 'pink', filter: 'lowpass', freq: 900, gain: 0.35, gust: { depth: 0.3, every: [3, 7] } },
      { src: { wave: 'sine', freqs: [3150, 3190, 4020] }, filter: 'bandpass', freq: 3500, q: 2, gain: 0.012, day: 0.8, night: 1.6, gust: { depth: 0.8, every: [1, 3] } },
      { src: 'white', filter: 'bandpass', freq: 2200, q: 0.7, gain: 0.08, night: 0.7, gust: { depth: 0.7, every: [1.5, 4], sweep: 1.4 } },
      { src: { wave: 'triangle', freqs: [87.3, 87.9, 130.8] }, filter: 'lowpass', freq: 400, gain: 0.03, night: 1.5 },
    ],
    events: [
      { kind: 'call', every: [7, 16], gain: 0.1, voices: 2, echo: 0.4 },
      { kind: 'insect', every: [5, 12], gain: 0.06, pitch: 1.4 },
      { kind: 'drip', every: [3, 8], gain: 0.12, voices: 2, echo: 0.45 },
      { kind: 'croak', every: [3, 8], gain: 0.08, day: 0.15, night: 1, pitch: 1.1 },
      { kind: 'songbird', every: [8, 18], gain: 0.09, day: 1, night: 0.2, pitch: 1.5 },
      { kind: 'chime', every: [14, 30], gain: 0.05, night: 1.5, echo: 0.5 },
      { kind: 'bubble', every: [10, 20], gain: 0.08, pitch: 2.2 },
    ],
    echo: { l: 0.28, r: 0.41, fb: 0.45, damp: 3500, wet: 0.7 },
  },
  music: {
    mood: 'wonder and strangeness (F lydian, 100 bpm)',
    score: {
      bpm: 100, steps: 16, root: 53, mode: MODES.lydian, progression: [0, 1, 0, 1, 4, 5, 3, 1],
      pad: { wave: 'triangle', voices: 4, detune: 10, cutoff: 2200, gain: 0.08, octave: 0, send: 0.4 },
      bass: { wave: 'sine', glide: 0.03, cutoff: 600, atk: 0.01, dec: 0.25, sus: 0.7, rel: 0.15, gain: 0.42, octave: -1,
        pattern: '1..1..5.1..1..8.', hot: '1.11.15.1.11.85.' },
      arp: { wave: 'sine', fm: { ratio: 3.5, index: 1.2, decay: 0.15 }, cutoff: 6000, atk: 0.002, dec: 0.3, sus: 0, rel: 0.2, gain: 0.11, octave: 1, send: 0.5,
        pattern: [0, -1, 2, 4, -1, 2, 1, -1, 3, -1, 5, 3, -1, 1, 2, -1], hot: [0, 2, 4, 2, 1, 3, 5, 3, 0, 2, 4, 2, 1, 3, 5, 6] },
      lead: { wave: 'triangle', cutoff: 3000, atk: 0.04, dec: 0.4, sus: 0.7, rel: 0.4, gain: 0.12, octave: 1, send: 0.5,
        vibrato: { rate: 4.5, cents: 20 }, bars: [4, 6],
        motifs: [
          { notes: [[4, 4], [6, 4], [5, 2], [4, 6], [2, 8], [null, 8]] },
          { notes: [[0, 2], [1, 2], [2, 4], [4, 4], [3, 4], [2, 8], [null, 8]] },
        ] },
      drums: { kit: 'soft', gain: 0.8,
        main: { kick: 'X.......x.X.....', snare: '....x.......x...', hat: 'x.xgx.xgx.xgx.xg' },
        fill: { tom: '..........x.x.xx' },
        hot: { kick: 'X...x...X.x.x...', snare: '....X..g....X..g', hat: 'xgxxxgxxxgxxxgxx', tom: '......x.......x.' } },
      echo: { steps: 3, fb: 0.4, wet: 0.25, damp: 3500 },
      level: 0.55,
    },
  },
};
